// extracted by mini-css-extract-plugin
export default {"container":"CxV2CvZd","icon":"XD8Z6pc5","text":"_TcupMYH"};